import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {DefaultRootState} from 'react-redux';

import {AppDispatchType} from 'app/store/AppStore';

export const DEFAULT_SCOPE = 'default';

export interface LoadingBarState {
  [scope: string]: number;
}

const initialState: LoadingBarState = {
  [DEFAULT_SCOPE]: 0,
};

const loadingBarSlice = createSlice({
  name: 'loadingBar',
  initialState,
  reducers: {
    showLoading: (
      state,
      {payload: scope = DEFAULT_SCOPE}: PayloadAction<string | void>
    ) => {
      state[scope] = (state[scope] || 0) + 1;
    },
    hideLoading: (
      state,
      {payload: scope = DEFAULT_SCOPE}: PayloadAction<string | void>
    ) => {
      state[scope] = Math.max(0, state[scope] || 0) - 1;
    },
    reset: (
      state,
      {payload: scope = DEFAULT_SCOPE}: PayloadAction<string | void>
    ) => {
      state[scope] = 0;
    },
  },
});

export const {showLoading, hideLoading, reset} = loadingBarSlice.actions;

export const loadingBarReducer = loadingBarSlice.reducer;

export const withLoadingIndicator =
  <T>(fn: () => Promise<T>) =>
  async (dispatch: AppDispatchType): Promise<T> => {
    const promise = fn().then((value) => {
      dispatch(hideLoading());
      return value;
    });
    dispatch(showLoading());
    return promise;
  };

export function loadingBarSelector(
  state: DefaultRootState,
  scope = DEFAULT_SCOPE
): number {
  return state.loadingBar[scope];
}
